import { render, staticRenderFns } from "./FileUploadIcon.vue?vue&type=template&id=2bff59aa&scoped=true&lang=html"
import script from "./FileUploadIcon.vue?vue&type=script&lang=js"
export * from "./FileUploadIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bff59aa",
  null
  
)

export default component.exports